let fsrCarBrands = []

document.onreadystatechange = async () => {
  fsrCarBrands = [...new Set(product_list.map(model => model["Ma"]))]
  
  let fsrCarRoofs = [...new Set(product_list.map(model => model["c"]))]
  fsrCarBrands = fsrCarBrands.sort()

  if (document.readyState === 'complete') {
    try{document.querySelector('#fsrCarLocationSelect').addEventListener("change", fsrLocationChange)}catch(e){console.log(e)}
    try{let fsrCarSelectContainer = document.getElementById('fsrCarSelect')
    
    let fsrCarSelectBrand = document.querySelector('#fsrCarBrandSelect .fsr-car-select')
	
    for(let i = 0 ; i < fsrCarBrands.length ; i++){
        let brandName = fsrCarBrands[i].charAt(0).toUpperCase() + fsrCarBrands[i].slice(1).toLowerCase()
    	let el = document.createElement('option')
        el.innerHTML = brandName
        el.setAttribute('value',brandName)
        fsrCarSelectBrand.appendChild(el)
    }
        
    fsrCarSelectBrand.addEventListener("change", fsrCarBrandChange)
    document.querySelector('#fsrCarYearSelect .fsr-car-select').addEventListener("change", fsrCarYearChange)
    document.querySelector('#fsrCarModelSelect .fsr-car-select').addEventListener("change", fsrCarModelChange)
    
    if(fsrgetCookie("Automarke") == undefined){
    	fsrCarBrandChange()
    }else if(fsrgetCookie("Automarke")!=""){
      	fsrCarBrandChangeCookie(fsrgetCookie("Automarke"))
    }else{
    	fsrCarBrandChange()
    }
    }catch(e){}
  }
}

function fsrCarBrandChangeCookie(brand){
	document.querySelector('#fsrCarBrandSelect .fsr-car-select [value="'+brand+'"]').selected = true;
    fsrCarBrandChange()
}

function fsrCarBrandChange(){
  	let fsrCarSelectBrand = document.querySelector('#fsrCarBrandSelect .fsr-car-select')
    let fsrCarSelectYear = document.querySelector('#fsrCarYearSelect .fsr-car-select')
    let fsrCarYearsObjects = product_list.filter(word => word["Ma"].toUpperCase() == fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex].value.toUpperCase());
  	let fsrCarYearsList = fsrCarYearsObjects.map(element=>element["Y"]);
	let fsrCarYears = fsrCarYearsList.filter((item,pos)=> fsrCarYearsList.indexOf(item) == pos).sort().reverse();
  console.log(document.getElementById('fsrCarSelectBrandinput'))
    document.getElementById('fsrCarSelectBrandinput').setAttribute('value', fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value)
    
  	fsrCarSelectYear.innerHTML = ''
  
    for(let i = 0 ; i < fsrCarYears.length ; i++){
     	 let el = document.createElement('option')
         el.innerHTML = fsrCarYears[i]
         el.setAttribute('value',fsrCarYears[i])
         fsrCarSelectYear.appendChild(el)
    }
    
  try{fsrsetCookie("Automarke",fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value,365)}catch(e){}
    if(fsrgetCookie("Baujahr") == undefined){
    	fsrCarYearChange()
    }else if(fsrgetCookie("Baujahr")!=""){
      	fsrCarYearChangeCookie(fsrgetCookie("Baujahr"))
    }else{
    	fsrCarYearChange()
    }
}

function fsrCarYearChangeCookie(year){
  try{document.querySelector('#fsrCarYearSelect .fsr-car-select [value="'+year+'"]').selected = true;}catch(e){}
  fsrCarYearChange()
}

function fsrCarYearChange(){
	let fsrCarSelectBrand = document.querySelector('#fsrCarBrandSelect .fsr-car-select')
    let fsrCarSelectYear = document.querySelector('#fsrCarYearSelect .fsr-car-select')
    let fsrCarSelectModel = document.querySelector('#fsrCarModelSelect .fsr-car-select')    
    let fsrCarYearsObjects = product_list.filter(word => word["Ma"].toUpperCase() == fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value.toUpperCase());
  
    let fsrCarModelsObject = fsrCarYearsObjects.filter(word => word["Ma"].toUpperCase() == fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value.toUpperCase() && word["Y"] == fsrCarSelectYear.options[fsrCarSelectYear.selectedIndex ].value);
	let fsrCarModelList = fsrCarModelsObject.map(element=>element["Mo"]);      
    let fsrCarModels = fsrCarModelList.filter((item,pos)=> fsrCarModelList.indexOf(item) == pos).sort(); 
  
    document.getElementById('fsrCarSelectYearinput').setAttribute('value', fsrCarSelectYear.options[fsrCarSelectYear.selectedIndex ].value)
  
  	fsrCarSelectModel.innerHTML = ''
  	
    for(let i = 0 ; i < fsrCarModels.length ; i++){
     	 let el = document.createElement('option')
         el.innerHTML = fsrCarModels[i]
         el.setAttribute('value',fsrCarModels[i])
         fsrCarSelectModel.appendChild(el)
    }  
  try{fsrsetCookie("Baujahr",fsrCarSelectYear.options[fsrCarSelectYear.selectedIndex ].value,365)}catch(e){}
    if(fsrgetCookie("Modell") == undefined){
    	fsrCarModelChange()
    }else if(fsrgetCookie("Modell")!=""){
      	fsrCarModelChangeCookie(fsrgetCookie("Modell"))
    }else{
    	fsrCarModelChange()
    }    
  	
}

function fsrCarModelChangeCookie(model){
  try{document.querySelector('#fsrCarModelSelect .fsr-car-select [value="'+model+'"]').selected = true;}catch(e){}
  fsrCarModelChange()		
}

function fsrCarModelChange(){
	let fsrCarSelectBrand = document.querySelector('#fsrCarBrandSelect .fsr-car-select')
    let fsrCarSelectYear = document.querySelector('#fsrCarYearSelect .fsr-car-select')
    let fsrCarSelectModel = document.querySelector('#fsrCarModelSelect .fsr-car-select')
    let fsrCarSelectRoof = document.getElementById('fsrCarRoofSelectWrapper')
       
  	let fsrCarRoofsObject = product_list.filter(word => word["Ma"].toUpperCase() == fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value.toUpperCase() && word["Y"] == fsrCarSelectYear.options[fsrCarSelectYear.selectedIndex ].value && word["Mo"] == fsrCarSelectModel.options[fsrCarSelectModel.selectedIndex ].value);
	let fsrCarRoofList = fsrCarRoofsObject.map(element=>element["c"]);       
    let fsrCarRoofs = fsrCarRoofList.filter((item,pos)=> fsrCarRoofList.indexOf(item) == pos);
    let fsrRoofMatching = {
      "a": `offene Dachreling`,
      "b": `bündig geschlossene Reling`,
      "c": `normales Dach`,
      "d": `integrierte Fixpunkte`,
      "e": `T-Profil`,
      "f": `integrierte Fixpunkte, mit Glasdach`,
      "g": `normales Dach, mit Glasdach`,
      "h": `werksseitig vorhandene Dachträger`,
    }
    fsrCarRoofs = fsrCarRoofs.map(roof => fsrRoofMatching[roof])
    
  
  	document.getElementById('fsrCarSelectModelinput').setAttribute('value',fsrCarSelectModel.options[fsrCarSelectModel.selectedIndex ].value)
    fsrCarSelectRoof.innerHTML = ''

    
    for(let i = 0 ; i < fsrCarRoofs.length ; i++){
      let el = document.createElement('div')
      el.classList.add('fsrCarRoofImage')
      el.setAttribute('onclick','fsrCarRoofChange(this)')
      if(i == 0){
        el.classList.add('fsrCarRoofImageActive')
        document.getElementById('fsrCarSelectRoofinput').setAttribute('value',fsrCarRoofs[i])
      }
      switch(fsrCarRoofs[i]){
        case 'offene Dachreling':
          el.innerHTML = `<img data-type="offene Dachreling" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/raised_rail.svg?v=1717496571" width="90%"> <span style="display:block">Offene Dachreling</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Erhöhte Reling mit Abstand zwischen Dach und Reling</span></span>`
          break;
        case 'bündig geschlossene Reling':
          el.innerHTML = `<img data-type="bündig geschlossene Reling" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/flush_rail.svg?v=1717496571" width="90%"> <span style="display:block">Bündig geschlossene Reling</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Reling ohne Zwischenraum zwischen Reling und Dach</span>`
          break;
        case 'normales Dach':
          el.innerHTML = `<img data-type="normales Dach" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/normal_roof.svg?v=1717496571" width="90%"> <span style="display:block">Normales Dach</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Leeres Fahrzeugdach, ohne Reling und Befestigungspunkte</span>`
          break;  
        case 'integrierte Fixpunkte':
          el.innerHTML = `<img data-type="integrierte Fixpunkte" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/fixpoint.png?v=1717503872" width="90%"> <span style="display:block">Integrierte Fixpunkte</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Dach mit werksseitig vorhandenen, fixen Befestigungspunkten</span>`
          break;
        case 'T-Profil':
          el.innerHTML = `<img data-type="T-Profil" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/fixpoint.png?v=1717503872" width="90%"><span style="display:block">T-Profil</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Vorhandene T-Nut-Schiene auf dem Fahrzeugdach</span> `
          break;
        case 'integrierte Fixpunkte, mit Glasdach':
          el.innerHTML = `<img data-type="integrierte Fixpunkte, mit Glasdach" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/fixpoint_w_glassroof.svg?v=1717496571" width="90%"><span style="display:block">Integrierte Fixpunkte, mit Glasdach</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Dach mit werksseitig vorhandenen, fixen Befestigungspunkten</span> `
          break;
        case 'normales Dach, mit Glasdach':
          el.innerHTML = `<img data-type="normales Dach, mit Glasdach" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/glas_roof.svg?v=1717496571" width="90%"> <span style="display:block">Normales Dach, mit Glasdach</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Leeres Fahrzeugdach, ohne Reling und Befestigungspunkte</span>`
          break; 
        case 'werksseitig vorhandene Dachträger':
          el.innerHTML = `<img data-type="werksseitig vorhandene Dachträger" src="https://cdn.shopify.com/s/files/1/0541/4967/7249/files/raised_rail.svg?v=1717496571" width="90%"><span style="display:block">Werksseitig vorhandene Dachträger</span>
    <span class="fsr-fc-g" style="font-size:10px;display:block;">Fahrzeug mit vorhandenen Dachträgern</span>`
          break; 
      }
      fsrCarSelectRoof.appendChild(el)
    }

    
  
    fsrsetCookie("Modell",fsrCarSelectModel.options[fsrCarSelectModel.selectedIndex ].value,365)

  console.log('fsrCarRoofs[0]')
  console.log(fsrCarRoofs[0])

  console.log('DACHTYP COOKIE:' + fsrgetCookie("Dachtyp") )
  
    if(fsrgetCookie("Dachtyp") == undefined){
    	fsrCarRoofChange()
    }else if(fsrgetCookie("Dachtyp")!="" && fsrCarRoofs.includes(fsrgetCookie("Dachtyp"))){
      	fsrCarRoofChangeCookie(fsrgetCookie("Dachtyp"))
    }else{
        fsrsetCookie("Dachtyp",fsrCarRoofs[0],365)
    	fsrCarRoofChange()
    }  
}

function fsrCarRoofChangeCookie(roof){
  try{
    document.querySelector('.fsrCarRoofImageActive').classList.remove('fsrCarRoofImageActive')
    document.querySelector('[data-type="'+roof+'"]').parentElement.classList.add('fsrCarRoofImageActive')
    document.getElementById('fsrCarSelectRoofinput').setAttribute('value',roof)
  }catch(e){
    console.log(e)
  }
  fsrCarRoofChange()		
}

function fsrCarRoofChange(e){
  if(e){
    document.querySelector('.fsrCarRoofImageActive').classList.remove('fsrCarRoofImageActive')
    e.classList.add('fsrCarRoofImageActive')
    document.getElementById('fsrCarSelectRoofinput').setAttribute('value',e.querySelector('img').dataset.type)
    fsrsetCookie("Dachtyp",e.querySelector('img').dataset.type,1)
    console.log('DACHTYP COOKIE SETZEN AUF:' + e.querySelector('img').dataset.type)
  }

  	let fsrCarSelectBrand = document.querySelector('#fsrCarBrandSelect .fsr-car-select')
    let fsrCarSelectYear = document.querySelector('#fsrCarYearSelect .fsr-car-select')
    let fsrCarSelectModel = document.querySelector('#fsrCarModelSelect .fsr-car-select')

    let fsrRoofMatching = {
      "offene Dachreling" :"a",
      "bündig geschlossene Reling":"b",
      "normales Dach":"c",
      "integrierte Fixpunkte":"d",
      "T-Profil":"e",
      "integrierte Fixpunkte, mit Glasdach":"f",
      "normales Dach, mit Glasdach":"g",
      "werksseitig vorhandene Dachträger":"h",
    }
  
  let cart_button = document.querySelector('button[type="submit"].product-form__cart-submit')
  let tent_notice = document.querySelector('.fsr-booking-notice[data-topic="no_tent"]')

  if(fsr_tent_compatibility_relevant){
  if(product_list
    .find(model => 
      model["Ma"].toUpperCase() == fsrCarSelectBrand.options[fsrCarSelectBrand.selectedIndex ].value.toUpperCase() &&
      model["Y"] == fsrCarSelectYear.options[fsrCarSelectYear.selectedIndex ].value &&
      model["Mo"] == fsrCarSelectModel.options[fsrCarSelectModel.selectedIndex ].value &&
      model["c"] == fsrRoofMatching[document.getElementById('fsrCarSelectRoofinput').value]
    )["T"] == "Yes"){
      if(cart_button){
        cart_button.removeAttribute('disabled')
      }
      document.querySelector('.fsr-booking-notices').classList.add('fsr-hide')
      tent_notice.classList.add('fsr-hide')
    } else {
      if(cart_button){
        cart_button.setAttribute('disabled', 'disabled')
      }
      document.querySelector('.fsr-booking-notices').classList.remove('fsr-hide')
      tent_notice.classList.remove('fsr-hide')
    }}

  
}